import { createContext } from 'react';

export const ActionModalHeightContext = createContext(false);
